/**
 * Marketplace model.
 */
export default {
  fields: {
    id: 0,
    name: '',
    title: '',
    domain: '',
    meta: {},
    credentialFields: {},
    templates: {},
    fields: {},
    language: {},
  },
  getDefaults() {
    return JSON.parse(JSON.stringify(this.fields));
  },
  /**
   * Returns completed fields from a response.
   * @param response
   */
  fromApiResponse(response) {
    return {
      id: response.id,
      name: response.name,
      language: response.language,
      domain: response.domain,
      title: response.title,
      meta: response.meta === null ? {} : response.meta,
      credentialFields: response.credentials_fields === null ? {} : response.credentials_fields,
      templates: response.templates === null
      || Array.isArray(response.templates) ? {} : response.templates,
      fields: response.fields === null || Array.isArray(response.fields) ? {} : response.fields,
    };
  },
  /**
   * Return an object for sending to a API
   * @param data
   */
  toApiRequest(data) {
    return {
      name: data.name,
      title: data.title,
      domain: data.domain,
      credentials_fields: data.credentialFields,
      templates: data.templates,
      fields: data.fields,
      language_id: data.language.id,
    };
  },
};
